import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Box } from "@material-ui/core";

interface Props {
  variant?: "text" | "outlined" | "contained";
  color?: "inherit" | "primary" | "secondary" | "default";
  btnText: string;
  btnIcon?: any;
  title: string;
  message: string;
  cancelBtnText: string;
  okBtnText: string;
  btnClassName?: string;
  btnDisabled?: boolean;
  onOpenClick?: () => boolean;
  onOkClick?: () => void;
  onCancelClick?: () => void;
}

export default function ButtonConfirmDialog({
  variant,
  color,
  btnText,
  btnIcon,
  title,
  message,
  cancelBtnText,
  okBtnText,
  btnClassName,
  btnDisabled,
  onOpenClick,
  onOkClick = () => {}
}: Props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    if (onOpenClick && onOpenClick() === false) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOkClick = () => {
    onOkClick();
    handleClose();
  };

  return (
    <>
      <Button
        variant={variant || "contained"}
        color={color || "primary"}
        className={btnClassName}
        disabled={btnDisabled}
        onClick={handleClickOpen}
      >
        {btnIcon || <></>}
        {btnText}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box p="10px">
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="primary" onClick={handleClose}>
              {cancelBtnText}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOkClick}
              autoFocus
            >
              {okBtnText}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
}
